// extracted by mini-css-extract-plugin
module.exports = {"input":"b4hcfa"};